import {BaseApi} from '@/core/api/base.api'
import {roomWaitingService} from "@/core/service/room.waiting.service";
import {roomWaitingEventApi} from '@/core/api/room.waiting.event.api'
import {grmWaitingRoomWebPubsubClient} from "@/core/GrmWaitingRoomWebPubsubClient";

class RoomWaitingApi extends BaseApi {
  #waitingRoomClient
  #event

  constructor() {
    super()
    this.#waitingRoomClient = grmWaitingRoomWebPubsubClient;
    this.#event = roomWaitingEventApi;
  }

  // for ws client
  async enter(data) {
    let assign = Object.assign(data, {
      roomId: data.roomId,
      oncomplete: async () => {
        await roomWaitingEventApi.runEvent();
      }
    });

    await this.getWaitingRoomClient().connect({ roomId : data.roomId, userId : data.userId});
    await assign.oncomplete();
  }

  async disconnect(reason) {
    await this.getWaitingRoomClient().disconnect(reason);
  }

  getWaitingRoomClient() {
    return this.#waitingRoomClient
  }

  // for apis

  async findAllByRoomId(params) {
    return (await roomWaitingService.findAllByRoomId(params)).data.data;
  }

  async isEnabled(params) {
    return (await roomWaitingService.isEnabled(params)).data.data;
  }

  async approve(params) {
    return (await roomWaitingService.approval(params)).data.data;
  }

  async disapprove(params) {
    return (await roomWaitingService.approval(params)).data.data;
  }

  async requestEnter(params) {
    return (await roomWaitingService.requestEnter(params)).data.data;
  }

  async leaveWaitingRoom(params) {
    return (await roomWaitingService.leave(params)).data.data;
  }

  async disableWaitingRoom(params) {
    return (await roomWaitingService.disableWaitingRoom(params)).data.data;
  }

  async testNoManagerInRoom(params) {
    return (await roomWaitingService.testNoManagerInRoom(params)).data.data;
  }

  async testCloseRoom(params) {
    return (await roomWaitingService.testCloseRoom(params)).data.data;
  }
}

export const roomWaitingApi = new RoomWaitingApi();
